// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"a0578b73","94":"fe8a9f6b","118":"fff7dad8","318":"48cb2f40","438":"6381de4b","453":"8e8b4867","816":"79a0ce14"}[chunkId] + ".chunk.css";
};